/* eslint-disable @typescript-eslint/no-magic-numbers */
import { DOCUMENT, isPlatformServer } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { Screen, ScreenService } from '../../services';

const INITIAL_TOP_CURVE_OFFSET = 30;
const INITIAL_TOP_CURVE_OFFSET_XL = 70;
const CURVE_RANGE_MAX = 50;
const CURVE_RANGE_MIN = -50;
@Component({
  selector: 'osn-shared-curve-animation',
  templateUrl: './curve-animation.component.html',
  styleUrls: ['./curve-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurveAnimationComponent implements AfterViewInit, OnDestroy {
  @Input() public disableBottomAnimation = false;
  @Input() public backgroundColor = '#0f0125';
  @Input() public showInitialTopCurve = false;

  @ViewChild('curveTop') public curveTop: ElementRef;
  @ViewChild('curveBottom') public curveBottom: ElementRef;

  @ViewChild('curveTopContainer') public curveTopContainer: ElementRef;
  @ViewChild('curveBottomContainer') public curveBottomContainer: ElementRef;

  public maskId = `mask-${Math.random() * 100}`;

  private readonly scrollEventListener = this.calculateCurve.bind(this);

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly screenService: ScreenService,
    @Inject(PLATFORM_ID) private readonly platformId
  ) {}

  public ngAfterViewInit() {
    this.document.addEventListener('scroll', this.scrollEventListener);
    this.calculateCurve();
  }

  public ngOnDestroy() {
    this.document.removeEventListener('scroll', this.scrollEventListener);
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  private calculateCurve() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    const position = this.curveTopContainer.nativeElement.getBoundingClientRect();
    const curveBottomPosition = !this.disableBottomAnimation && this.curveBottomContainer.nativeElement.getBoundingClientRect();
    // detecting if element is fully visible
    if (position.top < this.document.defaultView.innerHeight && position.bottom >= 0) {
      this.document.defaultView.requestAnimationFrame(() => {
        // valid range for result is 50 and -50
        const curveHeight = 125;
        let result = (position.top / this.document.defaultView.innerHeight) * curveHeight - CURVE_RANGE_MAX;
        if (this.showInitialTopCurve) {
          const offset = this.screenService.activeScreen === Screen.XL ? INITIAL_TOP_CURVE_OFFSET_XL : INITIAL_TOP_CURVE_OFFSET;
          result = result - offset > CURVE_RANGE_MIN ? result - offset : CURVE_RANGE_MIN;
        }
        this.curveTop.nativeElement.setAttribute('d', `M 800 50 Q 400 ${result} 0 50 Z`);
      });
    }
    // detecting if element is fully visible
    if (
      !this.disableBottomAnimation &&
      curveBottomPosition.top < this.document.defaultView.innerHeight &&
      curveBottomPosition.bottom >= 0
    ) {
      this.document.defaultView.requestAnimationFrame(() => {
        const top = curveBottomPosition.top / this.document.defaultView.innerHeight;
        const curveAnimationStartFrom = 0.5;
        const defaultCurvePosition = 125;
        const multiplier = 320;
        const result = top && top < curveAnimationStartFrom ? top * multiplier - 35 : defaultCurvePosition;
        this.curveBottom.nativeElement.setAttribute('d', `M 800 25 Q 400 ${result} 0 25 Z`);
        if (result < 25) {
          this.curveBottom.nativeElement.setAttribute('fill', '#000');
        } else {
          this.curveBottom.nativeElement.setAttribute('fill', '#fff');
        }
      });
    }
  }
}
